﻿import {useEffect} from "react";
import {getErrorMessageForNonStandardAndStandardResponse} from "../../util/NetworkErrorUtil";

import {SnackbarShowMessage} from "../../context/snackbar-context";

/** Alias for {@link SnackbarShowMessage}. */
export type SnackbarShowMessageType = SnackbarShowMessage;
interface UseSnackbarDisplayOnErrorParams {
  error: Error | undefined;
  snackbarShowMessage: SnackbarShowMessage;
}

/**
 * Custom hook to display a snackbar message when an error occurs.
 * @param error The error object to check for changes.
 * @param snackbarShowMessage The function to call to display the snackbar message.
 *
 * @see {@link useSnackbar} for obtaining the snackbarShowMessage function.
 *
 * @example - useSnackbar hook
 * const MyComponent () => {
 *   const { snackbarShowMessage } = useSnackbar();
 *   const [error, setError] = useState<Error | undefined>();
 *
 *   useSnackbarDisplayOnError({ error, snackbarShowMessage });
 *
 *   useEffect(() => {
 *     // some logic that may set the error state
 *   }, []);
 *
 *   return (
 *     // component JSX
 *   );
 * }
 * export default MyComponent;
 */
const useSnackbarDisplayOnError: (arg0: UseSnackbarDisplayOnErrorParams) => void = ({ error, snackbarShowMessage }) => {
  useEffect(() => {
    if (error) {
      snackbarShowMessage(getErrorMessageForNonStandardAndStandardResponse(error), 'error');
    }
  }, [error, snackbarShowMessage]);
}

export { useSnackbarDisplayOnError };
